import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { Outlet } from "../navigation";

export default function Settings() {
    const {t} = useTranslation()

    return (
        <>
            {/* @ts-ignore */}
            <Helmet>
                <title>{t('settings')} | Patent Cockpit</title>
            </Helmet>
            <Outlet />
        </>
    )
}
